import React from "react";
import LookerEmbed from "./LookerEmbed";

const CmsStats = () => {
  const REPORT_URL = "https://lookerstudio.google.com/embed/reporting/56fc2d43-ae94-429f-9b9d-d12d9c049c9e/page/kIV1C";

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="mx-auto max-w-[1280px] bg-white rounded-2xl shadow overflow-hidden">
        <div className="flex">

          <div className="flex-1 min-w-0 bg-neutral-50/70">
            <main className="pt-12 flex flex-col p-4 overflow-x-hidden w-full">
              <section className="px-4 py-2 w-full overflow-x-hidden">
                <div className="mb-3 flex items-center justify-between">
                  <h2 className="text-xl font-semibold mb-4">로그 통계</h2>
                </div>

                <LookerEmbed src={REPORT_URL} title="가입자 추이" lang="ko" height={600} />
              </section>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CmsStats;
